export function Landing() {
  return (
    <main className="landing-shell">
      <section className="landing-card">
        <div className="brand-mark" aria-hidden="true">W</div>
        <p className="eyebrow">WooCommerce product chatbot</p>
        <h1>A helpful shop assistant, grounded in your real catalogue.</h1>
        <p className="landing-copy">
          This service powers the product assistant for Furniture ’n Lighting.
          Administrators can manage the assistant, sync the catalogue, and help customers from the admin console.
        </p>
        <div className="landing-actions">
          <a className="button button-primary" href="/admin">Open admin console</a>
          <a className="button button-secondary" href="/health">Service health</a>
        </div>
      </section>
    </main>
  );
}
